<div class="slider">
  <div #track class="track bg-tertiary"></div>
  <div
    class="selected-min-track bg-primary"
    [ngStyle]="selectedMinTrackWidth()"
  ></div>
  <div
    class="selected-max-track bg-primary"
    [ngStyle]="selectedMaxTrackWidth()"
  ></div>
  <button
    type="button"
    class="min-thumb btn-primary bg-white"
    [ngStyle]="minThumbLeft()"
    [ngClass]="disabled() ? 'border-tertiary' : 'border-primary'"
    (pointerdown)="
      markAsTouched(); minThumbDown.set(true); ignoreClick.set(true)
    "
    (keydown)="markAsTouched(); onMinThumbKeydown($event)"
  ></button>
  <button
    type="button"
    class="max-thumb btn-primary bg-white"
    [ngStyle]="maxThumbRight()"
    [ngClass]="disabled() ? 'border-tertiary' : 'border-primary'"
    (pointerdown)="
      markAsTouched(); maxThumbDown.set(true); ignoreClick.set(true)
    "
    (keydown)="markAsTouched(); onMaxThumbKeydown($event)"
  ></button>
</div>
